// extracted by mini-css-extract-plugin
export default {"container":"loading_container__bPVzT","absolute":"loading_absolute__dmGyg","center":"loading_center__EIV9P","image":"loading_image__Gy8WO","input":"loading_input__r9XtL"};